module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAATCAYAAACQjC21AAABBUlEQVQ4ja3UvyuFcRTH8dfVU2zuQAbbzWDSlUx3UBZkMpht6tLdlYkyGKRkYpHJYDGZZBGb1J38AcokGZCE4fv40ePhPvL91LdT3855d87n1CmdVCoLGBdH+wn6MRIJeNEWCfShosBjPMYCruMQG7GATSziLhZwAHtpbKmkQM40BnFZBFikw1504TkW8AgTmMfLf4Gv2MQKJjGDW9z/VNDKw7U0zgkjX6EHU7hBFaso/QZ8wjZ20I0lDPmcZhbXOEADp6i9F2dHfhAORQfK2MVwJm9L8HQs7bj6FZDt8AydwiKWhe3mqZ6+b8oCR9GOPsGrPyvPw1rOX2FFP18JzoUFxFDzDZAnKYTUQeL1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdf.png
// module id = 538
// module chunks = 0